module.exports = __webpack_public_path__ + "img/arrow-up.9a8d24bd.svg";